import { useEffect, useRef } from 'react';

/**
 * คุมแท็บเบราว์เซอร์: ตัวเลขงานค้างบนชื่อแท็บ + ไอคอน (favicon) ตามบริษัท
 *
 * ทำไมต้องเก็บ/คืนค่าเดิม: React ไม่ได้จัดการ <title> กับ <link rel="icon"> ให้
 * ถ้าเปลี่ยนแล้วไม่คืน พอ logout หรือสลับบริษัทจะค้างเป็นของเดิม
 *
 * @param {object} opts
 * @param {number} [opts.count]       จำนวนงานค้าง (0/undefined = ไม่ใส่ตัวเลข)
 * @param {string} [opts.companyName] ชื่อบริษัท ใช้เป็นชื่อแท็บ
 * @param {string} [opts.logoUrl]     โลโก้บริษัท ใช้เป็น favicon
 */
export const useTabIndicator = ({ count = 0, companyName = '', logoUrl = null } = {}) => {
  const originalTitle = useRef(null);
  const originalIcon = useRef(null);

  // ---- ชื่อแท็บ ----
  useEffect(() => {
    if (originalTitle.current === null) originalTitle.current = document.title;
    const base = companyName || originalTitle.current || 'BackOffice';
    const n = Number(count) || 0;
    document.title = n > 0 ? `(${n}) ${base}` : base;
  }, [count, companyName]);

  // ---- favicon ----
  useEffect(() => {
    // หา/สร้าง <link rel="icon"> แล้วจำของเดิมไว้คืนตอน unmount
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    if (originalIcon.current === null) originalIcon.current = link.getAttribute('href') || '';

    link.setAttribute('href', logoUrl || originalIcon.current || '/favicon.ico');
  }, [logoUrl]);

  // คืนค่าเดิมตอนออกจากหน้า (logout / เปลี่ยน layout)
  useEffect(() => {
    return () => {
      if (originalTitle.current !== null) document.title = originalTitle.current;
      const link = document.querySelector("link[rel~='icon']");
      if (link && originalIcon.current !== null) link.setAttribute('href', originalIcon.current);
    };
  }, []);
};

export default useTabIndicator;
